/**
 * constants.ts — all static values for the SKU Migration feature
 */

import { ConversionType, BuyingModelFilter } from './types';

export const CONVERSION_TYPES = {
  NONE:      'none',
  CLONE:     'clone',
  ALC_TO_EA: 'alc_to_ea',
  EA_TO_ALC: 'ea_to_alc',
} as const;

export const CONVERSION_LABELS: Record<ConversionType, string> = {
  none:      'None',
  clone:     'Clone',
  alc_to_ea: 'ALC → EA',
  ea_to_alc: 'EA → ALC',
};

export const CONVERSION_DESCRIPTIONS: Record<ConversionType, string> = {
  none:      'Select a conversion type to continue.',
  clone:     'Creates a new SKU with the same config and buying model — only the name changes.',
  alc_to_ea: 'Creates a new EA SKU copying all config from the selected ALC SKU.',
  ea_to_alc: 'Creates a new ALC SKU copying all config from the selected EA SKU.',
};

/**
 * Which buying model filter to auto-apply per conversion type.
 * 'clone' shows all SKUs; ALC→EA shows only ALC; EA→ALC shows only EA.
 */
export const CONVERSION_BUYING_MODEL_FILTER: Record<ConversionType, BuyingModelFilter> = {
  none:      'all',
  clone:     'all',
  alc_to_ea: 'ALC',
  ea_to_alc: 'EA',
};

/**
 * What SubscriptionBuyingModel to write on the new SKU.
 * Empty string for clone means "copy from source".
 */
export const TARGET_BUYING_MODEL: Record<ConversionType, string> = {
  none:      '',
  clone:     '',    // resolved at submit time from sourceBuyingModel
  alc_to_ea: 'EA',
  ea_to_alc: 'ALC',
};

export const BUYING_MODEL_OPTIONS: { label: string; value: BuyingModelFilter }[] = [
  { label: 'All',  value: 'all' },
  { label: 'ALC',  value: 'ALC' },
  { label: 'EA',   value: 'EA'  },
];

export const MIGRATION_STEPS = [
  { title: 'Select SKUs', description: 'Filter and pick SKUs' },
  { title: 'Map Names',   description: 'Set target SKU names' },
  { title: 'Review',      description: 'Review & confirm'     },
];
